import { Input } from '@angular/core';
import { Component } from '@angular/core';

@Component({
  selector: 'wpro-login-call-failure',
  templateUrl: './login-call-failure.component.html',
  standalone: false
})
export class LoginCallFailureComponent {

  @Input() messageFlag: string;
  @Input() deviceInfoFlag: string;

  constructor() { }
}
